module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="bench" id="bench-'+
((__t=( bench.id ))==null?'':__t)+
'">\n\t<div class="bench-background"></div>\n\t<div class="bench-title fn-show-source">\n\t\t<h2 class="bench-title-text">\n\t\t\t<div>'+
((__t=( bench.name ))==null?'':__t)+
'</div>\n\t\t\t<span class="fn-bench-state bench-state">ready</span>\n\t\t\t<span class="fn-bench-result bench-result"></span>\n\t\t\t<span class="fn-bench-status bench-status"></span>\n\t\t</h2>\n\t\t<div class="bench-controls">\n\t\t\t<a href="#" class="fn-run-bench">'+
((__t=( dictionary.runBenchmark ))==null?'':__t)+
'</a>\n\t\t</div>\n\t</div>\n\t';

	var code = '';
	if (bench.originOption) {
		code += hilite('// options\n');
		code += hilite(JSON.stringify(bench.originOption, null, 2)) + '\n\n';
		code += hilite('// test\n');
	}
	code += hilite(fnstrip(bench.originFn));
	
__p+='\n\t<pre class="bench-source hidden"><code>'+
((__t=( code ))==null?'':__t)+
'</code></pre>\n</div>';
}
return __p;
};
